module.exports = __webpack_public_path__ + "static/media/print.70761c59.svg";